import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Home from "./Home/Home";
import Notfound from "./Notfound/Notfound";
import Contact from "./Contact/Contact";
import Terms from "./Terms/Terms";
import PrivacyPolicy from "./PrivacyPolicy/PrivacyPolicy";
import Start from "./Start/Start";
import PaymentRefundPolicy from "./PaymentRefundPolicy/PaymentRefundPolicy";
import Subscriptions from "./Subscriptions/Subscriptions";

const AnimateRoutes = () => {
  const location = useLocation();
  return (
    <>
      <AnimatePresence>
        <Routes location={location} key={location.pathname}>
          <Route path="" element={<Home />}></Route>
          <Route path="/contact-us" element={<Contact />}></Route>
          <Route path="/terms&conditions" element={<Terms />}></Route>
          <Route path="/privacy-Policy" element={<PrivacyPolicy />}></Route>
          <Route
            path="/payment&refund-policy"
            element={<PaymentRefundPolicy />}
          ></Route>
          <Route path="/start" element={<Start />}></Route>
          <Route path="/subscriptions" element={<Subscriptions />}></Route>

          <Route path="*" element={<Notfound />}></Route>
        </Routes>
      </AnimatePresence>
    </>
  );
};

export default AnimateRoutes;
